import * as api from "../constants/api";
import * as axiosUtils from "../utils/axiosUtils";

export const actionType = "MOTTAKERTYPER";

export function getMottakertyper() {
  return axiosUtils.GetAll(api.GET_MOTTAKERTYPER_URL, actionType);
}
